import { render } from "./DetalharTreinamento.vue?vue&type=template&id=1a820bdf&scoped=true"
import script from "./DetalharTreinamento.vue?vue&type=script&lang=js"
export * from "./DetalharTreinamento.vue?vue&type=script&lang=js"

import "./DetalharTreinamento.vue?vue&type=style&index=0&id=1a820bdf&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a820bdf"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QIcon,QInput});
